import { store } from "@/api";
import { ttsApi, type TranslateResult } from "@/api/ttsApi/tts";
import { getErrorMessage } from "@/utils/requestUtils";

export type { TranslateResult };

/**
 * Translates through the gateway, which holds the Google key. Goes via the
 * store rather than a bare fetch so an expired access token is refreshed and
 * the request replayed, like every other API call.
 */
export async function translateText(
  text: string,
  target: string,
): Promise<TranslateResult> {
  const request = store.dispatch(
    ttsApi.endpoints.translateText.initiate(
      { text, target },
      // Nothing reads this mutation from the cache; don't keep every message in it.
      { track: false },
    ),
  );
  try {
    return await request.unwrap();
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}
